import request from '@/utils/httpClient'
import { LogisticsCreateParams, LogisticsUpdateParams } from '@/types/domain/logistics'

// 创建物流记录
export function createLogistics(data: LogisticsCreateParams) {
  return request({
    url: 'logistics',
    method: 'POST',
    data
  })
}

// 更新物流记录
export function updateLogistics(id: number, data: LogisticsUpdateParams) {
  return request({
    url: `logistics/${id}`,
    method: 'put',
    data
  })
}
